import React from 'react';
import './Styles/Tables.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import { tablesData, tablesData2 } from './data';

const Tables=()=>{
    return(
        <div className="tables-part">
            <div className="section">
                <div>
                    <h1>All systems are go</h1>
                    <p>All products and integrations are operational.</p>
                </div>
                <StyledButton btn="Subscribe to update" styles="nobg-btn" />
            </div>
            <div className="tables">
                        <Table 
                        list={tablesData}
                        fade="fade-right"
                        />
                        <Table 
                        list={tablesData2}
                        fade="fade-left"
                        />
                </div>
        </div>
    )
};
export default Tables ;

export function Table(props){
    return(
        <div  data-aos={props.fade}
        data-aos-delay={100} className="table-status">
            {props.list.map((item) =>{
                return(
                    <div className="data">
                  <div className="left">
                      <p>{item.title}</p>
                      {item.icon ? <>{item.icon}</> : null}
                </div>
                <p className="link">Operational</p>
                </div>
                )
            })}
        </div>
    )
}